﻿//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
import * as moment from 'moment'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

import { CommonHelper } from '../../../helpers/common-helper'
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { EventsNames } from '../../../helpers/events-names'
import { i18n } from '../../common/i18n/common.i18n'
import {
    MeterFormValuesModel,
    AlarmDefModel,
    ColumnModel,
    MeterModel,
    GroupRequestModel,
    ResponseListModel,
    FieldModel,
    FieldNameValueModel
} from '../../api/api.models'
import { Md5 } from '../../../helpers/md5-helper'
import { DefinitionsBridge } from '../meters.controller'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { Permissions } from '../../../helpers/permissions'
import { ConfirmationSource } from '../../common/confirmation-popup/confirmation-popup.directive'
import { CommonCreateEdit, CreateEditSection, CreateEditFieldSettings } from '../../common/common.create-edit'
import { IUserSession } from '../../../helpers/user-session'
import { Enums } from '../../../models/common/enums'

import { TemplateHelper } from '../../../helpers/template-helper';
import { ConfigHelper } from '../../../helpers/config-helper';
import { ActionStatusOptions } from '../../common/action-status/action-status.controller';
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { ActionHelper } from '../../../helpers/action-helper'

export interface MeterDefinitionsEditScope extends ng.IScope {
    CONFIRM_SEND_DEVICE_CONFIGURATION_POPUP_ID: string

    id: any
    confirmationPopupId: number
    source: DefinitionsBridge
    groups: any[]
    addedNbr: number
    alarmTypes: ResponseListModel<ColumnModel>
    section: CreateEditSection
    defNameInputWidth: number
    //Grid props
    gridOptions: GridOptions
    gridData: any
    // End grid props

    // DX options
    startButtonOptions: DevExpress.ui.dxButtonOptions
    stopButtonOptions: DevExpress.ui.dxButtonOptions
    finishButtonOptions: DevExpress.ui.dxButtonOptions
    applyChangesButtonOptions: DevExpress.ui.dxButtonOptions
    sendDeviceConfigurationButtonOptions: DevExpress.ui.dxButtonOptions
    savingProgressOptions: DevExpress.ui.dxProgressBarOptions
    groupsContainerScrollOptions: DevExpress.ui.dxScrollViewOptions
    definitionsContainerScrollOptions: DevExpress.ui.dxScrollViewOptions
    groupsHeaderContainerScrollOptions: DevExpress.ui.dxScrollViewOptions
    addGroupButtonOptions: DevExpress.ui.dxButtonOptions
    availableGroupsSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    applyAdditionButtonOptions: DevExpress.ui.dxButtonOptions
    deleteGroupButtonOptions: DevExpress.ui.dxButtonOptions
    addNewGroupPopoverOptions: DevExpress.ui.dxPopoverOptions
    popupOptions: DevExpress.ui.dxPopupOptions
    nameInputPopup: DevExpress.ui.dxPopoverOptions
    defNameInput: DevExpress.ui.dxTagBoxOptions
    defNameScrollViewOptions: DevExpress.ui.dxScrollViewOptions
    // End DX options

    // Boolean flags
    isStarted: boolean
    finishSignal: boolean
    isApplyButtonDisabled: boolean
    isSubmitButtonDisabled: boolean
    isSubmittedSuccessfully: boolean
    showLoader: boolean
    disabledMeterAlarmDefFields: boolean
    isGroupEditEnabled: boolean
    deviceConfigurationSendAvailable: boolean
    showExtendedData: boolean
    showGrid: boolean
    isBulk: boolean
    nameInputPopupVisible: boolean
    popupVisible: boolean
    showContent: boolean
    headersVisible: boolean
    //End boolean flags

    // Methods
    deleteGroup: (group) => void
    updateMD5: (isNew: boolean) => void
    acceptName: () => void
    saveChanges: (params: any) => void
    addElement: () => void
    // End methods

    // Dictionary fields
    meterAlarmDefFields: ColumnModel[]
    meterAlarmDefRefsFields: ColumnModel[]
    // End dictionary fields

    uploadedPercent: number
    actualSavedMeter: number

    availableGroups: any[]

    confirmationPopupSource: ConfirmationSource
    confirmSendConfigurationSource: ConfirmationSource
}

export class MeterDefinitionsEditController extends CommonCreateEdit {
    previousDefsMd5: any
    requestFailed: boolean = false

    addedName: string[]
    removedDefs: any[]
    formData: any
    initialData: FieldModel[]

    currentAlarmDefs: any[]
    currentAlarmDefsFor: number
    originalAlarmDefs: any[]
    createGridPromise = $.Deferred<void>()
    gridId: any
    selectedNewGroup: any
    gridColumns: any
    name: string
    closingConfirmed: boolean

    templates: any[]
    validationResults = []

    editedItems: any = {}

    // DX objects
    private popup: DevExpress.ui.dxPopup
    addNewGroupPopover: DevExpress.ui.dxPopup
    groupsContainerScroll: DevExpress.ui.dxScrollView
    definitionsContainerScroll: DevExpress.ui.dxScrollView
    groupsHeaderContainerScroll: DevExpress.ui.dxScrollView
    grid: DevExpress.ui.dxDataGrid
    availableGroupsSelectBox: DevExpress.ui.dxSelectBox
    applyAdditionButton: DevExpress.ui.dxButton
    deleteGroupButton: DevExpress.ui.dxButton
    defNameScrollView: DevExpress.ui.dxScrollView
    // End DX objects

    constructor(protected $scope: MeterDefinitionsEditScope, protected $q: ng.IQService, protected $timeout: ng.ITimeoutService, protected api: Api, protected logger: LoggerService,
        protected localDictionary: LocalDictionaryFactory, protected userSession: IUserSession) {
        super($scope, api, localDictionary, $q, $timeout, userSession)
        $scope.showContent = false
        $scope.isApplyButtonDisabled = true
        $scope.isSubmitButtonDisabled = true
        this.closingConfirmed = false
        $scope.availableGroups = []
        $scope.section = <any>{}
        $scope.confirmationPopupId = new Date().getTime()

        $scope.CONFIRM_SEND_DEVICE_CONFIGURATION_POPUP_ID = $scope.id + 'sendDeviceConfiguration'

        if (!$scope.alarmTypes) {
            api.dictionary.getAlarmTypes().then(c => {
                $scope.alarmTypes = c
            })
        }

        localDictionary.getMeterAlarmDefFields().then((cols) => {
            $scope.meterAlarmDefFields = cols
            $scope.disabledMeterAlarmDefFields = cols.length === 0
        })

        localDictionary.getMeterAlarmDefRefsFields().then((cols) => {
            $scope.meterAlarmDefRefsFields = cols
        })

        jQuery.when.apply(jQuery, [Permissions.ALARM_GROUP_EDIT, Permissions.DEVICE_CONFIGURATION_SEND].map(p => Permissions.hasPermissions([p]))).then((...permissions) => {
            const [alarmGroupEdit, deviceConfigurationAvailable] = permissions
            $scope.isGroupEditEnabled = !(!alarmGroupEdit)
            $scope.deviceConfigurationSendAvailable = !(!deviceConfigurationAvailable)
        })

        $scope.isBulk = false
        $scope.showGrid = false
        $scope.uploadedPercent = 0
        $scope.isStarted = false
        $scope.actualSavedMeter = 0
        $scope.finishSignal = false

        $scope.$watchCollection('source.groups', val => {
            $scope.groups = _.clone($scope.source ? $scope.source.groups : [])
        })

        $scope.$on(EventsNames.ALARM_GROUPS_UPDATED, (event, ...args) => {
            this.getAlarmGroups()
        })

        $scope.$on(EventsNames.ALARM_DEF_UPDATED, (event, ...args) => {
            this.onAlarmDefUpdate()
        })

        //this.getAlarmGroups()

        $scope.startButtonOptions = {
            text: i18n('Popup', 'Start'),
            bindingOptions: {
                disabled: 'isStarted'
            },
            onClick: () => {
                this.saveEntities()
            }
        }

        $scope.stopButtonOptions = {
            text: i18n('Popup', 'Stop'),
            bindingOptions: {
                disabled: '!isStarted'
            },
            onClick: () => {
                this.stopSaving()
            }
        }

        $scope.finishButtonOptions = {
            text: i18n('Popup', 'Finish'),
            bindingOptions: {
                disabled: 'isStarted'
            },
            onClick: () => {
                this.finishSaving()
            }
        }

        $scope.deleteGroup = (group) => {
            $scope.groups.splice($scope.groups.indexOf(group), 1)
            const groupWithoutDefs = _.clone(group)
            groupWithoutDefs.alarmGroupDefs = []
            $scope.availableGroups.push(groupWithoutDefs)
            $scope.availableGroups = _.sortBy($scope.availableGroups, gr => gr.name)
            $scope.isSubmitButtonDisabled = false
            $scope.source.items.forEach(item => {
                item.opState = CommonHelper.ChangeState.Modified
            })

            $scope.$broadcast(EventsNames.ALARM_DEF_GROUP_DELETED, group)
        }

        $scope.savingProgressOptions = {
            visible: true,
            statusFormat: (ratio, value) => {
                return i18n('Popup', 'Progress') + ': ' + Math.round(ratio * 100) + '%'
            },
            bindingOptions: {
                value: 'uploadedPercent'
            },
            value: 0,
            min: 0,
            max: 100
        }

        $scope.confirmationPopupSource = {
            confirmYes: () => {
                this.sendConfigurationToDevice()
            },
            confirmNo: () => {
                this.closingConfirmed = true
                this.popup.hide()
            }
        }

        $scope.confirmSendConfigurationSource = {
            confirmYes: () => {
                this.sendConfigurationToDevice()
            },
            confirmNo: () => { }
        }

        $scope.addGroupButtonOptions = {
            template: TemplateHelper.getIconWithAdditionalIcon(ConfigHelper.Icon.ALARM_GROUPS, ConfigHelper.Icon.ADD, userSession),
            onInitialized: e => {

            },
            onClick: e => {
                this.addNewGroupPopover.toggle(true)
            },
            bindingOptions: {
                disabled: '!isGroupEditEnabled'
            }
        }

        $scope.addNewGroupPopoverOptions = {
            onInitialized: e => {
                this.addNewGroupPopover = e.component
            },
            title: i18n('Popup', 'GroupEdit'),
            target: '#addGroupButton' + $scope.id
        }

        $scope.deleteGroupButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, this.userSession, { iconSize: Enums.SimaxIconSize.Small }),
            onInitialized: e => {
                this.deleteGroupButton = e.component
            },
            bindingOptions: {
                disabled: '!isGroupEditEnabled'
            }
        }

        $scope.availableGroupsSelectBoxOptions = {
            onInitialized: e => {
                this.availableGroupsSelectBox = e.component
            },
            bindingOptions: {
                items: 'availableGroups'
            },
            searchEnabled: true,
            displayExpr: 'name',
            valueExpr: 'name',
            width: 250,
            noDataText: i18n('Common', 'NoData'),
            placeholder: i18n('Common', 'Select'),
            onSelectionChanged: e => {
                this.selectedNewGroup = e.selectedItem
                if (e.selectedItem)
                    $scope.isApplyButtonDisabled = false
                else
                    $scope.isApplyButtonDisabled = true
            }
        }

        $scope.applyAdditionButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, this.userSession),
            onInitialized: e => {
                this.applyAdditionButton = e.component
            },
            onClick: e => {
                $scope.availableGroups.splice(_.findIndex($scope.availableGroups, gr => gr.id === this.selectedNewGroup.id), 1)
                $scope.groups.push(this.selectedNewGroup)
                this.addNewGroupPopover.toggle(false)
            }
        }

        $scope.definitionsContainerScrollOptions = {
            onInitialized: e => {
                this.definitionsContainerScroll = e.component
            },
            direction: 'vertical',
            onScroll: e => {
                this.groupsContainerScroll.scrollTo({ top: e.scrollOffset.top })
            },
            height: '100%',
            showScrollbar: 'never'
        }

        $scope.groupsContainerScrollOptions = {
            onInitialized: e => {
                this.groupsContainerScroll = e.component
            },
            direction: 'both',
            onScroll: e => {
                this.definitionsContainerScroll.scrollTo({ top: e.scrollOffset.top })
                this.groupsHeaderContainerScroll.scrollTo({ left: e.scrollOffset.left })
            },
            height: '100%',
            width: 'auto'
        }

        $scope.groupsHeaderContainerScrollOptions = {
            onInitialized: e => {
                this.groupsHeaderContainerScroll = e.component
            },
            direction: 'horizontal',
            onScroll: e => {

            },
            width: 'auto',
            height: 60,
            showScrollbar: 'never'
        }

        $scope.applyChangesButtonOptions = {
            text: i18n('Common', 'Submit'),
            onClick: e => {
                $scope.isSubmitButtonDisabled = true
                this.closingConfirmed = false
                $scope.saveChanges(null)
            },
            bindingOptions: {
                disabled: 'isSubmitButtonDisabled'
            }
        }

        $scope.sendDeviceConfigurationButtonOptions = {
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice), ConfigHelper.Icon.DEVICES, this.userSession),
            onClick: e => {
                $scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.confirmationPopupId, i18n('Popup', 'DoYouWantToSendConfigurationToDevice'))
            },
            bindingOptions: {
                disabled: '!isSubmittedSuccessfully'
            }
        }

        if (!$scope.id) $scope.id = new Date().getTime()

        $scope.$on(EventsNames.OPEN_METER_DEFINITIONS_EDIT_POPUP_BY_STRING_OF_PARAMS + $scope.id, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.source = null
            $scope.gridData = null
            this.gridColumns = null
            this.removedDefs = []
            $scope.isBulk = false
            this.currentAlarmDefs = null

            if (args[0]) {
                let modelId

                const params = CommonHelper.getParamsArrayFromString(args[0])
                params.forEach(param => {
                    switch (param.arg) {
                        case 'IdMeter':
                            modelId = param.value
                            break
                        case 'Id':
                            modelId = param.value
                            break
                    }
                })

                if (modelId > 0) {
                    $scope.showContent = false;
                    $scope.popupVisible = true
                    $timeout(() => {
                        $q.all([api.meter.getMeter(modelId)]).then(result => {
                            this.name = result[0].name
                            this.alarmDefBridge(modelId, this.name, result[0])
                        })
                    })
                }
            }
        })

        $scope.$on(EventsNames.OPEN_METER_DEFINITIONS_EDIT_POPUP + $scope.id, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.showContent = false
            $scope.popupVisible = true
            this.getAlarmGroups()

            this.createParamsForm()

            this.removedDefs = []

            if ($scope.source && $scope.source.items) {
                this.checkIfShowExtended()
            }

            if (args[0]) {
                //GRID
                if (args && args[1]) {
                    $scope.gridData = args[1]
                }

                if (args && args[2]) {
                    this.gridColumns = args[3]
                }

                $scope.source = args[2]
                this.currentAlarmDefs = angular.copy(args[2].items)
                this.currentAlarmDefsFor = args[2].idMeter
                this.originalAlarmDefs = args[2].originalDefs
                $scope.source.popupTitle = i18n('Common', 'AlarmDefsBulkSave')
                $scope.isBulk = true

                $scope.nameInputPopup.target = "#submitPopoverBulk" + $scope.id

                this.createGrid()
            }
            this.previousDefsMd5 = null
            $scope.showContent = true
        })

        $scope.$on(EventsNames.DELETE_METER_DEF, (event: ng.IAngularEvent, ...args: any[]) => {
            if (args[0].isNew) {
                $scope.source.items.splice($scope.source.items.map(f => { return f.name }).indexOf(args[0].name), 1)
            }
            else if (args[0].isNewFromTemplate) {
                $scope.source.items.splice($scope.source.items.map(f => { return f.$$hashKey }).indexOf(args[0].$$hashKey), 1)
                const templates = this.templates.filter(template => template.name == args[0].name)
                if (templates.length > 0) {
                    templates[0].showDef = true
                }
            }
            else {
                $scope.source.items.map(def => {
                    if (def.id === args[0].id) {
                        if (!def.toDelete) {
                            this.removedDefs.push(args[0].id)
                            def.toDelete = true
                        } else {
                            this.removedDefs = this.removedDefs.filter(d => {
                                return d != args[0].id
                            })
                            def.toDelete = false
                        }
                    }
                })
            }

            this.checkHeadersVisibility()

            $scope.source.items.forEach(el => el.showDef = true)
            $scope.source.items.filter(item => item.id === 0 && !(item.isNew || item.isNewFromTemplate)).forEach(el => {
                el.idDataTypeConfig = el.originalIdDataTypeConfig
                el.systemAlarmValue = el.originalSysAlarmVal
                if ($scope.source.items.filter(e => e.name == el.name).length > 1)
                    el.showDef = false
            })
            this.checkIfShowExtended()
        })

        $scope.addedNbr = 0;

        $scope.popupVisible = false
        $scope.popupOptions = {
            showTitle: true,
            showCloseButton: true,
            fullScreen: true,
            bindingOptions: {
                visible: 'popupVisible',
                title: 'source.popupTitle',
                'toolbarItems[0].text': 'source.meter.name'
            },
            onHiding: e => {
                $scope.nameInputPopupVisible = false
                if ($scope.isSubmittedSuccessfully &&
                    !this.closingConfirmed &&
                    $scope.deviceConfigurationSendAvailable &&
                    $scope.source.connectedDevice &&
                    $scope.source.connectedDevice.connectedObjectVisibility
                ) {
                    e.cancel = true
                    $scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.CONFIRM_SEND_DEVICE_CONFIGURATION_POPUP_ID, i18n('Popup', 'SendConfigurationToDeviceQuestion'))
                    return
                }

                if ($scope.source) {
                    $scope.source.items = $scope.source.items.filter(f => {
                        return !f.isNew && !f.isNewFromTemplate
                    })

                    // Removing unsaved alarm groups from alarm definitions
                    $scope.source.items.forEach((item: any) => {
                        if (_.isArray(item.currentAlarmDefGroups)) {

                            item.currentAlarmDefGroups.forEach((alarmDefGroup: any) => {
                                if (alarmDefGroup.opState === Enums.OpChangeState.Delete) {
                                    alarmDefGroup.opState = Enums.OpChangeState.Loaded
                                }
                            })

                            item.currentAlarmDefGroups = item.currentAlarmDefGroups.filter((alarmDefGroup: any) => alarmDefGroup.opState == Enums.OpChangeState.Loaded)
                        }
                    })
                }
                if (this.addNewGroupPopover)
                    this.addNewGroupPopover.hide()
                $scope.$emit('refreshDefsGrid')
                $scope.$broadcast('refreshDefsForm')

                if ($scope.isBulk) {
                    this.closePopup()
                }
                this.previousDefsMd5 = null
            },
            onShowing: e => {
                $scope.isSubmittedSuccessfully = false
                $scope.isSubmitButtonDisabled = true
                this.closingConfirmed = false

                if (this.availableGroupsSelectBox) {
                    this.availableGroupsSelectBox.option('value', undefined)
                }

                if ($scope.source) {
                    $scope.source.items = $scope.source.items.filter(f => {
                        return !f.isNew && !f.isNewFromTemplate
                    })

                    this.checkHeadersVisibility()

                    this.refreshDefs()
                    this.previousDefsMd5 = null
                    this.$scope.finishSignal = false

                    if ($scope.source.items.filter((item: { id: number, isNew: boolean, isNewFromTemplate: boolean }) => item.id != 0 || item.id == 0 && (item.isNew || item.isNewFromTemplate)).length === 0) {
                        this.templates.forEach((template: { showDef: boolean }) => {
                            this.addDefFromTemplate(template)
                            template.showDef = false
                            const currentMd5 = this.getMD5()
                            this.previousDefsMd5 = currentMd5
                            $scope.isSubmitButtonDisabled = false
                        })
                    }
                }
            },
            toolbarItems: [{
                disabled: false,
                location: 'center',
                toolbar: 'top',
                visible: true
            }],
            onInitialized: e => {
                this.popup = e.component
            }
        }

        $scope.addElement = () => {
            const templates = _.clone(this.templates)
            $scope.defNameInput.dataSource = templates.filter(t => t.showDef);
            ($scope.defNameInput.dataSource as any).forEach(t => {//replacing field 'visible' to field 'isVisible' in alarm definition. property visible is used in dataSource and if false DE dont show such record
                if ('visible' in t) {
                    t.isVisible = t.visible
                    delete t.visible
                }
            })
            $scope.nameInputPopupVisible = true
        }
        var firstOpen: boolean = true

        $scope.defNameScrollViewOptions = {
            width: '100%',
            direction: 'horizontal',

            onInitialized: (e: any) => {
                this.defNameScrollView = e.component
            }
        }

        $scope.defNameInput = <DevExpress.ui.dxTagBoxOptions>{
            bindingOptions: {
                acceptCustomValue: '!disabledMeterAlarmDefFields'
            },

            applyValueMode: 'useButtons',
            displayExpr: 'name',
            hideSelectedItems: false,
            noDataText: i18n('Common', 'NoData'),
            placeholder: '',
            showDropDownButton: true,
            showSelectionControls: true,
            valueExpr: 'name',
            height: 36,

            onCustomItemCreating: (args) => {
                const newItem = { name: args.text }
                const component = args.component
                const currentItems = component.option("dataSource")
                const existingItem = _.find(currentItems, (item: any) => item.name === newItem.name)

                if (!existingItem) {
                    currentItems.unshift(newItem);
                    component.option("dataSource", currentItems);

                    const selectedValues = component.option('value')
                    selectedValues.push(newItem.name)
                    component.option('value', selectedValues)

                    return newItem;
                }

                return null
            },

            onInitialized: (e: any) => {
                const maxTextLenght = Math.max(...($scope.defNameInput.dataSource as any).map(d => d.name.length))
                const width = maxTextLenght * 9
                $scope.defNameInputWidth = width < 250 ? 250 : width
            },

            onKeyPress: (e: any) => {
                if (this.defNameScrollView) {
                    this.defNameScrollView.scrollBy({ left: this.defNameScrollView.scrollWidth() })
                }
            },

            onOpened: (e: any) => {
                var $popover = $('.dx-overlay-content.dx-popup-normal.dx-popup-draggable.dx-resizable.dx-dropdowneditor-overlay-flipped')
                var offcet: number = 0
                var currentWidth: number = $popover.width()
                offcet = currentWidth - $scope.defNameInputWidth
                $popover.width($scope.defNameInputWidth).css('left', offcet)
            },

            onValueChanged: (e) => {
                this.addedName = e.value

                if (this.defNameScrollView) {
                    this.defNameScrollView.scrollBy({ left: this.defNameScrollView.scrollWidth() })
                }

                // Ten repaint jest po to, żeby po sytuacji w której zostanie dodany tag
                // z rozjeżdżającą wartością i przesunie popup w kosmos to repaint to poprawi
                if (e.component != null && _.isFunction(e.component.repaint)) {
                    e.component.repaint()
                }
            },
        }

        $scope.acceptName = () => {
            if (!this.addedName || this.addedName.length == 0)
                return
            this.addedName.forEach(addedName => {
                if (!$scope.source.items.some((f) => f.name == addedName && f.id != 0 && !(f.isNew || f.isNewFromTemplate))) {
                    if ((addedName.trim() !== '')) {
                        const templates = this.templates.filter(template => template.name.toLowerCase() == addedName.toLowerCase())
                        if (templates.length > 0) {
                            const template = templates[0]
                            this.addDefFromTemplate(template)
                            template.showDef = false
                        } else {
                            $scope.source.items.push({ id: 0, name: addedName, showDef: true, isEnabled: 'true', isNew: true, isVisible: true, readOnly: false })
                        }

                        this.textBoxReset()
                        $scope.isSubmitButtonDisabled = false
                        $timeout(() => {
                            this.checkIfShowExtended()
                        }, 500)
                    } else {
                        this.textBoxReset()
                        CommonHelper.openInfoPopup(i18n("Popup", "AlarmDefNameError"), 'error')
                    }
                } else {
                    this.textBoxReset()
                    CommonHelper.openInfoPopup(i18n("Popup", "DefExists"), 'error')
                }
            })

            this.checkHeadersVisibility()
        }

        $scope.nameInputPopupVisible = false
        $scope.nameInputPopup = {
            width: 'auto',
            target: "#submitPopover" + $scope.id,
            visible: true,
            onHidden: () => {
                this.textBoxReset()
            }
        }

        $scope.$on('AfterSaveAndDownloadAlarmsDefs', (event: ng.IAngularEvent, ...args: any[]) => {
            this.onSubmittedAlarmDefs(args[0])
        })

        $scope.saveChanges = () => {
            const defs = this.getDefsFromGrid($scope.source)
            const fields = this.getFieldsFromForm()
            let paramsFormValid: boolean = true

            if ($scope.section != null && $scope.section.form != null) {
                const result: DevExpress.ui.dxValidationGroupResult = $scope.section.form.validate()

                if (result != null) {
                    paramsFormValid = result.isValid
                }
            }

            if (paramsFormValid && this.validationResults.every(res => res.isValid)) {
                const currentMd5 = this.getMD5()

                if (this.previousDefsMd5 !== currentMd5 || this.requestFailed) {
                    $scope.showLoader = true
                    this.previousDefsMd5 = currentMd5
                    $scope.groups = []
                    $scope.isSubmittedSuccessfully = false

                    $scope.source
                        .onSubmit(defs, this.removedDefs, fields)
                        .then(() => {
                            this.requestFailed = false

                            if ($scope.deviceConfigurationSendAvailable)
                                $scope.isSubmittedSuccessfully = true

                            this.getAlarmGroups()
                            $scope.$root.$broadcast(EventsNames.UPDATE_SCHEMAS)
                        })
                        .catch(() => {
                            $scope.isSubmittedSuccessfully = false
                            this.requestFailed = true
                            $scope.showLoader = false
                        })
                        .finally(() => {
                            $timeout(() => {
                                this.checkHeadersVisibility()
                            })
                        })
                }

                this.validationResults = []
            }
            else {
                CommonHelper.openInfoPopup(i18n('Common', 'IncorrectData'), 'error', 5000)

                this.validationResults = []
            }
        }

        $scope.updateMD5 = _.debounce((isNew: boolean) => {
            if (!isNew)
                this.previousDefsMd5 = this.getMD5()
        }, 500)
    }

    extractTemplatesFromDefinitions(defs: any[]) {
        const templates = []
        const items = []
        defs.forEach(def => {
            if (def.id <= 0)
                templates.push(def)
            else
                items.push(def)
        })

        return { templates, items }
    }

    getDefsFromGrid(source) {
        const defs = []
        source.items.forEach(item => {
            if (item.isNewFromTemplate) {
                const defFromTemplate = this.addDefFromTemplateItem(item)
                if (defFromTemplate)
                    defs.push(defFromTemplate)
            }
            else if (item.isNew) {
                const newDef = this.addNewDef(item)
                if (newDef)
                    defs.push(newDef)
            }
            else if (item.id != 0) {
                const def = this.modifyDef(item)
                if (def)
                    defs.push(def)
            }
        })
        return defs
    }

    validateDxGroup(item: any) {
        return item.validationGroup ? item.validationGroup.validate() : { isValid: true }
    }

    addDefFromTemplateItem(item: any) {
        const res = this.validateDxGroup(item)
        this.validationResults.push(res)
        if (res.isValid) {
            const def = new AlarmDefModel()
            def.name = item.name
            //must stay until webservice returns correct config id
            def.idDataTypeConfig = (item.isOwnRef && !!item.systemAlarmValue) ? 0 : item.idDataTypeConfig
            //end of what must stay
            def.idDataTypeAlarm = item.idDataTypeAlarm
            def.systemAlarmValue = def.idDataTypeConfig > 0 ? null : item.systemAlarmValue
            def.idAlarmType = item.idAlarmType
            def.id = 0
            def.isEnabled = item.isEnabled
            def.currentAlarmDefGroups = item.currentAlarmDefGroups ? item.currentAlarmDefGroups.map(dg => dg) : []
            def.opState = item.opState
            return def
        }
        return null
    }

    modifyDef(item: any) {
        const res = this.validateDxGroup(item)
        this.validationResults.push(res)
        if (res.isValid) {
            const def = new AlarmDefModel()
            def.name = item.name
            def.idDataTypeConfig = (item.isOwnRef && !!item.systemAlarmValue) ? 0 : item.idDataTypeConfig
            def.idDataTypeAlarm = item.idDataTypeAlarm
            def.systemAlarmValue = def.idDataTypeConfig > 0 ? null : item.systemAlarmValue
            def.idAlarmType = item.idAlarmType
            def.id = item.id
            def.isEnabled = item.isEnabled
            def.currentAlarmDefGroups = item.currentAlarmDefGroups ? item.currentAlarmDefGroups.map(dg => dg) : []
            def.opState = item.opState
            return def
        }
        return null
    }

    addNewDef(item: any) {
        if (item.isNew) {
            const res = this.validateDxGroup(item)
            this.validationResults.push(res)
            if (res.isValid) {
                const def = new AlarmDefModel()
                def.name = item.name
                def.idDataTypeConfig = (item.isOwnRef && !!item.systemAlarmValue) ? 0 : item.idDataTypeConfig
                def.idDataTypeAlarm = item.idDataTypeAlarm
                def.systemAlarmValue = def.idDataTypeConfig > 0 ? null : item.systemAlarmValue
                def.idAlarmType = item.idAlarmType
                def.id = 0
                def.isEnabled = item.isEnabled
                def.currentAlarmDefGroups = item.currentAlarmDefGroups ? item.currentAlarmDefGroups.map(dg => dg) : []
                def.opState = CommonHelper.ChangeState.New
                return def
            }
        }
        return null
    }

    checkIfShowExtended() {
        const a = this.$scope.source.items.some((item) => item.isNew)
        if (a) {
            this.$scope.showExtendedData = true
        }
        else {
            this.$scope.showExtendedData = false
        }
    }

    createGrid = () => {
        this.$scope.gridOptions = null
        this.$timeout(() => {
            this.$scope.gridOptions = {
                type: GridTypes.PAGINATED_SMALL,
                idReferenceType: Enums.ReferenceType.None,
                name: 'meterDefinitionsEditGrid',
                columns: this.gridColumns,
                dataSource: new DataSource(this.$scope.gridData),
                onInitialized: e => {
                    this.grid = e.component
                    this.gridId = e.tableId
                    this.createGridPromise.resolve()
                },
                editing: {
                    mode: 'cell',
                    allowAdding: false,
                    allowUpdating: false,
                    allowDeleting: false
                },
                masterDetail: {
                    enabled: true,
                    template: function (container, options) {
                        const error = options.data.error;
                        if (error) {
                            container.append($('<div ><p>' + error + '</p></div>'));
                        }
                    },
                    autoExpandAll: false
                },
                onRowPrepared: e => {
                    if (e.rowType == "data") {
                        const row = $(e.rowElement)
                        if (e.data.success) {
                            row.css('background-color', '#02E6A1')
                            row.children('td').css('background-color', 'inherit')
                        }
                        else if (e.data.error) {
                            e.isExpanded = true
                            row.css('background-color', '#F7484E')
                            row.children('td').css('background-color', 'inherit')
                        }
                    }
                },
                addCustomFilters: false,
                preExecuteClearFilter: true,
                buttonsOptions: {
                    enabled: true
                }
            }

            this.$scope.showGrid = true
        })
    }

    saveEntities = () => {
        const currentMd5 = this.getMD5()
        if (this.previousDefsMd5 != currentMd5) {
            this.previousDefsMd5 = currentMd5

            if (this.$scope.gridData.length == this.$scope.actualSavedMeter) {
                this.terminateSaving()
            }

            const defs = this.getDefsFromGrid(this.$scope.source)
            if (this.validationResults.every(res => res.isValid)) {
                this.$scope.isStarted = true
                this.saveMetersAlarmDefs(defs)
                this.validationResults = []
            }
            else {
                this.validationResults = []
            }
        }
    }

    stopSaving() {
        this.$scope.isStarted = false
        this.previousDefsMd5 = null
    }

    finishSaving() {
        this.$scope.finishSignal = true
        this.$scope.popupVisible = false
    }

    closePopup() {
        this.gridColumns = []
        this.$scope.gridData = []
        this.$scope.isStarted = false
        this.$scope.actualSavedMeter = 0
        this.$scope.uploadedPercent = 0
    }

    terminateSaving() {
        this.$scope.isStarted = false
        this.$scope.actualSavedMeter = 0
        this.calculateUpload()
        this.restoreGrid()
        this.$scope.finishSignal = false
    }

    restoreGrid() {
        for (let i = 0; i < this.$scope.gridData.length; i++) {
            this.$scope.gridData[i].success = null
            this.$scope.gridData[i].error = null
        }

        this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
        this.grid.repaint()
        this.grid.collapseAll(-1)
    }

    saveMetersAlarmDefs(defs: AlarmDefModel[]) {
        if (!this.$scope.finishSignal) {
            if (this.$scope.isStarted) {
                if (this.$scope.gridData.length > this.$scope.actualSavedMeter) {
                    const meterId = this.$scope.gridData[this.$scope.actualSavedMeter].id
                    this.saveSingleAlarmDef(defs, meterId)
                }
                else {
                    this.$scope.isStarted = false
                }
            }
        }
        else {
            this.terminateSaving()
        }
    }

    saveSingleAlarmDef = (defs: AlarmDefModel[], meterId: number) => {
        //saving
        const currentAlarmDefsDefer = this.$q.defer<any[]>()
        if (meterId == this.currentAlarmDefsFor) {
            currentAlarmDefsDefer.resolve(this.originalAlarmDefs)
        } else {
            this.api.meter.getAlarmDefs(meterId).then(alarmDefs => {
                if (alarmDefs) {
                    let alarmDefsRet = alarmDefs.values ? alarmDefs.values : []

                    alarmDefsRet = alarmDefsRet.map((alarmDef) => {
                        alarmDef.id = +alarmDef.id
                        alarmDef.showDef = true
                        return alarmDef
                    })

                    currentAlarmDefsDefer.resolve(alarmDefsRet)
                }
                currentAlarmDefsDefer.reject("Can't download alarms defs for: " + meterId)
            })
        }
        currentAlarmDefsDefer.promise.then(currentAlarmDefs => {
            const alarmsDefs: AlarmDefModel[] = []
            currentAlarmDefs.filter(cAlarmDef => cAlarmDef.id > 0).forEach(cAlarmDef => {
                // modified
                const modifiedAlarmDefs = defs.filter(aDef => aDef.idDataTypeAlarm == cAlarmDef.idDataTypeAlarm)
                const modifiedAlarmDef = modifiedAlarmDefs.length > 0 ? modifiedAlarmDefs[0] : null
                if (modifiedAlarmDef) {
                    modifiedAlarmDef.id = cAlarmDef.id
                    alarmsDefs.push(modifiedAlarmDef)
                } else {
                    // loaded
                    alarmsDefs.push(cAlarmDef)
                }
            })
            // new
            defs.forEach(aDef => {
                if (alarmsDefs.filter(ad => ad.idDataTypeAlarm == aDef.idDataTypeAlarm).length == 0) {
                    alarmsDefs.push(aDef)
                }
            })
            currentAlarmDefs = currentAlarmDefs.map((alarm: AlarmDefModel) => {
                return <AlarmDefModel>{
                    currentAlarmDefGroups: alarm.currentAlarmDefGroups,
                    id: alarm.id,
                    idAlarmText: alarm.idAlarmText,
                    idAlarmType: alarm.idAlarmType,
                    idDataTypeAlarm: alarm.idAlarmType,
                    idDataTypeConfig: alarm.idDataTypeConfig,
                    indexNbr: alarm.indexNbr,
                    isEnabled: alarm.isEnabled,
                    name: alarm.name,
                    opState: alarm.opState,
                    systemAlarmValue: alarm.systemAlarmValue
                }
            })
            const formModel = new MeterFormValuesModel()
            formModel.alarmDefs = alarmsDefs
            formModel.currentAlarmDefs = currentAlarmDefs
            formModel.removedAlarmDefs = []
            formModel.id = meterId

            return this.api.meter.saveMeter(formModel).then(response => {
                let error = false
                if (!response) {
                    this.$scope.gridData[this.$scope.actualSavedMeter].error = i18n("Common", "WebServiceException")
                    error = true
                }
                else {
                    if (response.hasErrorCode && response.hasErrorCode > 0) {
                        this.$scope.gridData[this.$scope.actualSavedMeter].error = CommonHelper.getErrorMessage(response.hasErrorCode, response.errorMessage)
                        error = true
                    }
                    else {
                        this.$scope.gridData[this.$scope.actualSavedMeter].success = "success"
                    }
                }
                this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                this.grid.repaint()
                if (error)
                    this.grid.expandRow(this.$scope.gridData[this.$scope.actualSavedMeter])

                this.$scope.actualSavedMeter++
                this.calculateUpload()
                this.saveMetersAlarmDefs(defs)
            })
        }).catch(err => {
            console.log(err)
        })
    }

    textBoxReset() {
        this.$scope.nameInputPopupVisible = false
        this.addedName = []
    }

    calculateUpload() {
        this.$scope.uploadedPercent = (this.$scope.actualSavedMeter / this.$scope.gridData.length) * 100
    }

    onAlarmDefUpdate() {
        this.$scope.isSubmitButtonDisabled = false
        this.$scope.isSubmittedSuccessfully = false
    }

    refreshDefs() {
        this.$scope.source.items.forEach(el => el.showDef = true)
        this.$scope.source.items.filter(item => item.id <= 0).forEach(el => {
            if (!this.$scope.isBulk && this.$scope.source.items.filter(e => e.name == el.name && e.id != 0).length > 0)
                el.showDef = false
        })

        const defs = this.extractTemplatesFromDefinitions(this.$scope.source.items)
        this.templates = defs.templates
    }

    saveFormModel(formModel: MeterFormValuesModel, isDefs: boolean = false) {
        const deferred = this.$q.defer<MeterModel>()
        if (formModel) {
            this.api.meter.saveMeter(formModel).then(response => {
                if (!response.hasErrorCode) {
                    this.$scope.$root.$broadcast(EventsNames.UPDATE_METERS, response)
                    if (!isDefs)
                        CommonHelper.openInfoPopup(i18n('Popup', 'MeterSaved'))
                    if (isDefs)
                        CommonHelper.openInfoPopup(i18n('Popup', 'MeterDefSaved'))
                    deferred.resolve(response)
                }
                else
                    deferred.reject()
            }).catch(err => {
                if (!isDefs)
                    CommonHelper.openInfoPopup(i18n('Popup', 'MeterSaveError'), 'error', 5000)
                if (isDefs)
                    CommonHelper.openInfoPopup(i18n('Popup', 'MeterDefSaveError'), 'error', 5000)
                deferred.reject()
            })
        }
        return deferred.promise;
    }

    getMD5() {
        return Md5.init({
            defs: this.$scope.source.items.map(item => {
                const cloneItem = _.clone(item)
                delete cloneItem.$$hashKey
                delete cloneItem.validationGroup
                return cloneItem
            }),
            groups: this.$scope.groups,
            params: this.$scope.section.formData
        })
    }

    addDefFromTemplate(template) {
        const newDef = <any>{}
        newDef.id = 0
        newDef.isNewFromTemplate = true
        newDef.name = template.name
        newDef.idDataTypeConfig = (template.isOwnRef && !!template.systemAlarmValue) ? 0 : template.idDataTypeConfig
        newDef.idDataTypeAlarm = template.idDataTypeAlarm
        newDef.systemAlarmValue = newDef.idDataTypeConfig > 0 ? null : template.systemAlarmValue
        newDef.idAlarmType = template.idAlarmType
        newDef.showDef = true
        newDef.dataTypeAlarmDescr = template.dataTypeAlarmDescr
        newDef.dataTypeAlarmName = template.dataTypeAlarmName
        newDef.ownRefType = template.ownRefType
        newDef.idDataTypeClass = template.idDataTypeClass
        newDef.isEnabled = true
        newDef.isVisible = template.isVisible
        newDef.readOnly = template.readOnly
        this.$scope.source.items.push(newDef)
        this.checkIfShowExtended()
    }

    alarmDefBridge(modelId: number, name: string, meter: MeterModel) {
        this.api.meter.getAlarmDefs(modelId).then(alarmDefs => {
            if (alarmDefs) {
                this.$timeout(() => {
                    alarmDefs.values = alarmDefs.values.map((alarmDef) => {
                        alarmDef.id = +alarmDef.id
                        return alarmDef
                    })
                    const bridgeAlarmDefs = alarmDefs.values ? alarmDefs.values : []
                    let currentAlarmDefs = angular.copy(bridgeAlarmDefs)
                    this.$scope.source = {
                        id: modelId,
                        distributorId: 0,
                        items: bridgeAlarmDefs,
                        popupTitle: i18n('Popup', 'MeterAlarmDefEdit'),
                        meter: meter,
                        connectedDevice: {
                            connectedObjectId: meter.currentDeviceId || 0,
                            connectedObjectName: meter.currentDeviceName || '',
                            connectedObjectVisibility: !!meter.currentDeviceId,
                            connectedObjectTitle: i18n('Common', 'CurrentDevice'),
                            connectedObjectMethod: 'device'
                        },
                        onSubmit: (defs, removed, fields?) => {
                            const formModel = new MeterFormValuesModel()
                            formModel.id = this.$scope.source.id
                            formModel.alarmDefs = defs
                            formModel.removedAlarmDefs = removed
                            formModel.currentAlarmDefs = currentAlarmDefs.map(cad => {
                                delete cad.validationGroup
                                return cad
                            })
                            formModel.fields = fields

                            return this.saveFormModel(formModel, true).then(r => {
                                let alarmDefsItems = []
                                if (r.alarmDefs)
                                    alarmDefsItems = r.alarmDefs.values ? r.alarmDefs.values : []
                                this.onSubmittedAlarmDefs(alarmDefsItems)
                                currentAlarmDefs = _.clone(alarmDefsItems)

                                this.refreshDefs()
                                this.checkIfShowExtended()

                                this.$scope.isSubmittedSuccessfully = true

                                return true
                            }).catch(() => {
                                this.$scope.showLoader = false
                                this.$scope.isSubmittedSuccessfully = false

                                return false
                            }).finally(() => {
                                this.api.meter.getAlarmGroups(this.$scope.source.id).then(result => {
                                    if (!this.$scope.source) this.$scope.source = <DefinitionsBridge>{}
                                    this.$scope.source.groups = result && result.values ? result.values : []
                                    this.$scope.groups = _.clone(this.$scope.source.groups)
                                    return
                                }).then(() => {
                                    this.$scope.showLoader = false
                                    this.getAlarmGroups()
                                })
                            })
                        }
                    }

                    this.createParamsForm()
                    this.refreshDefs()
                    this.$scope.showContent = true;
                    return
                })
            }
        }).then(() => {
            return this.api.meter.getAlarmGroups(modelId)
        }).then(alarmGroups => {
            if (!this.$scope.source) this.$scope.source = <DefinitionsBridge>{}
            this.$scope.source.groups = alarmGroups.values
            this.getAlarmGroups()
        })
    }

    sendConfigurationToDevice() {
        this.closingConfirmed = true
        this.sendDeviceConfiguration()
        this.$scope.isSubmittedSuccessfully = false
    }

    sendDeviceConfiguration() {
        const meterName: string = (this.$scope.source && this.$scope.source.meter) ? this.$scope.source.meter.name : ''

        ActionHelper
            .sendDeviceConfiguration(this.userSession.getDataProvider(), [this.$scope.source.connectedDevice.connectedObjectId], [meterName])
            .then((actionStatusOptions: ActionStatusOptions) => {
                this.$scope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.$scope.id, actionStatusOptions)
            })
    }

    getAlarmGroups() {
        Permissions.hasPermissions([Permissions.ALARM_GROUP_LIST]).then(permission => {
            if (permission) {
                const activeView = this.localDictionary.getActiveView(CommonHelper.IdAlarmGroup)
                if (activeView) {
                    const primaryColumn = activeView.getPrimaryKeyColumn()

                    const column = new ColumnModel()
                    column.id = primaryColumn.idDataType
                    column.name = primaryColumn.name

                    const request = new GroupRequestModel()
                    request.columns = [column]

                    return this.api.group.getAlarmGroups(request).then(result => {
                        if (result && !result.hasErrorCode) {
                            this.$scope.availableGroups = []

                            result.result.forEach(group => {
                                if (this.$scope.source && !_.find(this.$scope.source.groups, gr => gr.id === group.id)) {
                                    this.$scope.availableGroups.push(group)
                                }
                            })
                            this.$scope.availableGroups = _.sortBy(this.$scope.availableGroups, gr => gr.name)
                        }
                        return
                    })
                }
            }
        })
    }

    createParamsForm() {
        this.localDictionary.getMeterAlarmDefPanelFields(this.$scope.source.meter ? this.$scope.source.meter.idMeterTypeClass : null).then((cols) => {
            this.initialData = this.$scope.source.meter ? this.$scope.source.meter.detailsFields : []
            this.formData = {}
            this.initialData.forEach(fd => {
                this.formData[fd.idDataType || fd.id] = fd
            })

            this.$scope.section.columns = <CreateEditFieldSettings[]>(<any>cols || [])
            this.$scope.section.options = <DevExpress.ui.dxFormOptions>{
                onFieldDataChanged: (e: any) => {
                    if (this.formData[e.dataField]) {
                        var oldValue = this.formData[e.dataField].value
                        if (this.formData[e.dataField].typeId == CommonHelper.datetime || this.formData[e.dataField].typeId == CommonHelper.date) {
                            oldValue = moment(oldValue).toDate()
                            if (oldValue.getTime() != e.value.getTime()) {
                                this.editedItems[e.dataField] = true
                            } else if (oldValue.getTime() == e.value.getTime()) {
                                this.editedItems[e.dataField] = false
                            }
                        } else {
                            if (oldValue != e.value) {
                                this.editedItems[e.dataField] = true
                            } else if (oldValue == e.value) {
                                this.editedItems[e.dataField] = false
                            }
                        }
                    }

                    this.trackFormChanges(e.dataField, e.value, e.previousValue)
                },
                requiredMark: '*',
                showRequiredMark: true,
                labelLocation: 'top',
                width: '100%',
                height: '100%',
                colCount: 3,
                scrollingEnabled: true,
                bindingOptions: {
                    formData: 'section.formData',
                    items: 'section.items',
                },
                onInitialized: e => {
                    this.$scope.section.form = e.component
                    this.loadForm(this.$scope.section, this.formData, 'form', CommonHelper.IdMeter, true)
                }
            }
        })
    }

    trackFormChanges(dataField, value, previousValue) {
        if ([undefined, null].indexOf(value) < 0 || previousValue)
            this.onAlarmDefUpdate()
    }

    getFieldsFromForm(): FieldNameValueModel[] {
        const fields = []

        if (!this.$scope.section.formData) {
            return fields
        }

        Object.keys(this.$scope.section.formData).forEach(property => {
            const idDataType = parseInt(property)
            const found = _.find(this.initialData, value => value.idDataType === idDataType)

            const id = found ? found.id : 0
            let state: Enums.OpChangeState = Enums.OpChangeState.Loaded

            if (id === 0) {
                state = Enums.OpChangeState.New
            } else {
                if (this.editedItems[idDataType]) {
                    state = Enums.OpChangeState.Modified
                }
            }

            const nameValue = new FieldNameValueModel()
            nameValue.idDataType = idDataType
            nameValue.id = id ? id : 0
            nameValue.index = 0
            nameValue.value = this.$scope.section.formData[property]
            nameValue.state = state
            fields.push(nameValue)
        })

        return fields
    }

    checkHeadersVisibility() {
        if (!this.$scope.source || !this.$scope.source.items)
            this.$scope.headersVisible = false
        else
            this.$scope.headersVisible = this.$scope.source.items.some(it => (it.id || it.isNew || it.isNewFromTemplate) && it.isVisible)
    }

    onSubmittedAlarmDefs(items) {
        this.removedDefs = []
        this.$scope.source.items = items

        this.refreshDefs()
        this.checkIfShowExtended()
        this.$scope.showLoader = false
    }
}